











































import {
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { ScriptValidacion } from '@/interfaces/ContratoProveedor';
import CodeView from '@/reusable/CodeView/CodeView.vue';

@Component({
  components: {
    CabeceraModal,
    GuardarButton,
    ModalMantenedor,
    ContenidoModal,
    FormFieldsContainer,
    CodeView,
  },
})
export default class CrearScriptModal extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) modoEditar: boolean;
  @Prop() scriptSeleccionado: ScriptValidacion;
  @Prop() titulo: string;

  formFields: FormFieldDefMap = {
    nombre: {
      label: 'Nombre',
      id: 'nombre',
      value: '',
    },
    script: {
      label: '',
      id: 'script',
      value: '',
    },
  };

  beforeMount() {
    this.handleScriptSeleccionadoChange();
  }

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
  }

  @Watch('scriptSeleccionado', { deep: true })
  handleScriptSeleccionadoChange() {
    if (this.scriptSeleccionado) {
      this.formFields.nombre.value = this.scriptSeleccionado.nombre;
      this.formFields.script.value = this.scriptSeleccionado.script;
    }
  }

  handleCerrar() {
    this.formFields.nombre.value = '';
    this.formFields.script.value = '';
    this.$emit('cerrar');
  }

  async handleGuardar() {
    const isValid = await this.$validator.validateAll();

    if (isValid) {
      var scriptValidacion: ScriptValidacion = {
        nombre: this.formFields.nombre.value.toString(),
        script: this.formFields.script.value.toString(),
      };

      if (!this.modoEditar) {
        this.$emit('crear', scriptValidacion);
      } else {
        this.$emit('editar', scriptValidacion);
      }

      this.handleCerrar();
    }
  }

  handleBlur(valor: string) {
    this.formFields.script.value = valor;
  }
}
